import React from 'react';
import PropTypes from 'prop-types';

export const SvgThumbsUp = ({ width, height }) => (
  <svg width={width || '16px'} height={height || '16px'} viewBox="0 0 16 16" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-148.000000, -330.000000)" stroke="#000000" strokeWidth="2">
        <g transform="translate(144.000000, 326.000000)">
          <path d="M13.3333333,10 L13.3333333,7.33333333 C13.3333333,6.22876383 12.4379028,5.33333333 11.3333333,5.33333333 L8.66666667,11.3333333 L8.66666667,18.6667531 L16.1866667,18.6667531 C16.8515245,18.6741829 17.4203074,18.1907174 17.52,17.5333333 L18.44,11.5333333 C18.498704,11.1465702 18.3845981,10.7535392 18.1279057,10.4583429 C17.8712132,10.1631466 17.4978345,9.99557024 17.1066667,10 L13.3333333,10 Z M8.66666667,18.6666667 L6.66666667,18.6666667 C5.930287,18.6666667 5.33333333,18.069713 5.33333333,17.3333333 L5.33333333,12.6666667 C5.33333333,11.930287 5.930287,11.3333333 6.66666667,11.3333333 L8.66666667,11.3333333 L8.66666667,18.6666667 Z" />
        </g>
      </g>
    </g>
  </svg>
);

SvgThumbsUp.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
